import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { fetchCurrentUserAndHandler } from './redux/currentUserManager/currentUserManager'
import { domains } from './lib/config'
import lmsApi from './lib/CfcLmsApi'
import ssApi from './lib/Api'
import documentServiceApi from './lib/DocumentServiceApi'
import { Container } from 'reactstrap'
import {
  HeaderContainer as Header,
  FooterContainer as Footer,
} from '@cfc/secondstep-header'
import { withAuth0 } from '@auth0/auth0-react'
import NotificationList from 'components/NotificationList'
import Loading from 'components/Loading/Loading'
import ModalContainer from './containers/modal/ModalContainer'
import AdminNavBar from 'components/AdminNavBar'
import EditProfileForm from './containers/account/EditProfileForm'
import CssAdmin from './containers/css-admin/CssAdmin'
import SelTraining from './containers/static-training/SelTraining'
import SelTrainingResource from './containers/static-training/SelTrainingResource'
import BpuTraining from './containers/static-training/BpuTraining'
import BpuTrainingResource from './containers/static-training/BpuTrainingResource'
import CpuTraining from './containers/static-training/CpuTraining'
import CpuTrainingResource from './containers/static-training/CpuTrainingResource'
import GlobalNav from './components/GlobalNav'
import FirstTimeUserNav from './components/FirstTimeUserNav'
import { ThemeProvider } from 'styled-components'
import theme from './theme/main'
import { setCookie } from './lib/util'

class App extends Component {
  static propTypes = {
    appInsights: PropTypes.object.isRequired,
    auth0: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      showFooter: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.hasAuthChanged(this.props, prevProps)) {
      this.handleAuthUpdate(this.props)
    }
  }

  hasAuthChanged(curProps, prevProps) {
    return (
      curProps.auth0.isLoading !== prevProps.auth0.isLoading ||
      curProps.auth0.isAuthenticated !== prevProps.auth0.isAuthenticated ||
      (curProps.auth0.user &&
        prevProps.auth0.user &&
        curProps.auth0.user.nickname !== prevProps.auth0.user.nickname)
    )
  }

  async handleAuthUpdate(props) {
    const { auth0, dispatch } = props
    if (!auth0.isLoading && !auth0.isAuthenticated) {
      let pathname = window.location.pathname + window.location.search
      if (pathname === '/') pathname = '/css-admin/licenses'
      setCookie('pathname', pathname)
      auth0.loginWithRedirect()
    } else if (auth0.isAuthenticated) {
      ssApi.setAuthInstance(auth0)
      lmsApi.setAuthInstance(auth0)
      documentServiceApi.setAuthInstance(auth0)
      dispatch(fetchCurrentUserAndHandler())
    }
  }

  signout() {
    const { auth0 } = props
    auth0.logout({ redirectTo: domains.PUBLIC_SITE_DOMAIN })
  }

  toggleFooter = show => this.setState({ showFooter: show })

  render() {
    const { showFooter } = this.state
    const { history, currentUser, isLoading, auth0 } = this.props
    const { isAuthenticated, logout } = auth0

    if (!isAuthenticated || !currentUser) return null

    return (
      <React.Fragment>
        <Loading isLoading={!currentUser && isLoading} />
        <ThemeProvider theme={theme}>
          {currentUser.isFirstTimeUser || !currentUser.hasUpdatedProfile ? (
            <FirstTimeUserNav />
          ) : (
            <GlobalNav />
          )}

          <Container style={{ marginTop: '2rem', paddingBottom: '0.5rem' }}>
            <NotificationList />
            {currentUser.isAdmin && (
              <AdminNavBar
                isCssAdmin={currentUser.isCssAdmin}
                isOperationsAdmin={currentUser.isOperationsAdmin}
                isTechnologyAdmin={currentUser.isTechnologyAdmin}
              />
            )}
            <Switch>
              <Route component={EditProfileForm} path="/account-details" />

              <Route
                path="/logout"
                render={() => {
                  this.signout()
                  history.push('/')
                  return null
                }}
              />
              {currentUser && currentUser.isAdmin && (
                <Route
                  path="/css-admin"
                  render={props => (
                    <CssAdmin
                      {...props}
                      isCssAdmin={currentUser.isCssAdmin}
                      isOperationsAdmin={currentUser.isOperationsAdmin}
                      isTechnologyAdmin={currentUser.isTechnologyAdmin}
                      showFooter={this.toggleFooter}
                    />
                  )}
                />
              )}
              <Route
                path="/second-step-online-training"
                render={() => <SelTraining showFooter={this.toggleFooter} />}
              />
              <Route
                path="/second-step-online-training-resources"
                render={() => (
                  <SelTrainingResource showFooter={this.toggleFooter} />
                )}
              />
              <Route
                path="/bullying-prevention-training"
                render={() => <BpuTraining showFooter={this.toggleFooter} />}
              />
              <Route
                path="/bullying-prevention-training-resources"
                render={() => (
                  <BpuTrainingResource showFooter={this.toggleFooter} />
                )}
              />
              <Route
                path="/child-protection-training"
                render={() => <CpuTraining showFooter={this.toggleFooter} />}
              />
              <Route
                path="/child-protection-training-resources"
                render={() => (
                  <CpuTrainingResource showFooter={this.toggleFooter} />
                )}
              />
              <Route
                path="/signout"
                render={async () => {
                  await logout({ returnTo: domains.PUBLIC_SITE_DOMAIN })
                  return null
                }}
              />
            </Switch>
          </Container>
          <ModalContainer />
          {!isLoading && showFooter && (
            <div
              style={{
                marginTop: '4.375rem',
              }}
            >
              <Footer domains={domains} />
            </div>
          )}
        </ThemeProvider>
      </React.Fragment>
    )
  }
}

function mapStateToProps({ currentUserManager }) {
  return {
    ...currentUserManager,
  }
}

export default withRouter(withAuth0(connect(mapStateToProps)(App)))



// WEBPACK FOOTER //
// ./src/App.js